import { useRef, useState } from "react";
import { AiOutlineDown } from "react-icons/ai";

import CourseSubSectionAccordion from "./CourseSubSectionAccordion";

const CourseAccordionBar = ({ courseName, courseList }) => {
  const [isActive, setIsActive] = useState(false);
  const contentEl = useRef(null);

  return (
    <div className="overflow-hidden border border-solid rounded-sm mb-2 border-richblack-600 bg-richblue-5 bg-opacity-50 text-richblue-700 last:mb-0">
      <div
        className={`flex cursor-pointer items-start justify-between bg-opacity-20 px-7 py-6 transition-[0.3s]`}
        onClick={() => setIsActive(!isActive)}
      >
        <div className="flex items-center gap-2">
          <i className={`transition-transform duration-300 ${isActive ? "rotate-180" : "rotate-0"}`}>
            <AiOutlineDown />
          </i>
          <p>{courseName}</p>
        </div>
        <div className="space-x-4">
          <span className="text-richblue-400">{`${courseList.length || 0} lecture(s)`}</span>
        </div>
      </div>
      
      {isActive && (
        <div
          ref={contentEl}
          className="bg-richblack-900"
        >
          <div className="text-textHead flex flex-col gap-2 px-7 py-6 font-semibold">
            {courseList.map((subSec, i) => {
              return <CourseSubSectionAccordion subSec={subSec} key={i} />;
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default CourseAccordionBar;
